import React from 'react';
import TransformSection from './common/transform-section';
import PlaceholderIdentitySection from './shared/placeholder-identity-section';
import SlotFilterSection from './shared/slot-filter-section';
import VisibleWhenSection from './shared/visible-when-section';
import type { ObjectInspectorProps } from './types';

/**
 * Rendered when a multi-selection spans different object kinds. Shared
 * transform (no X/Y in bulk) always applies. When every selected object is a
 * placeholder (e.g. a team_logo image + a team_name text), the identity
 * section is reused as-is — it already degrades gracefully for mixed kinds
 * (disabled "Ключ" dropdown, teamNumber/playerNumber/matchNumber still
 * common-editable) and already renders "Матч №" / "Команда №", so the slot
 * filter section is skipped there to avoid a duplicate field. Otherwise fall
 * back to the slot filter, which applies to any object kind and self-gates by
 * template type. The bracket's «Условие показа» applies to both branches — it
 * self-gates by type and drops its own pair/side fields for placeholders.
 */
const MixedInspector: React.FC<ObjectInspectorProps> = ({ objects, editor }) => {
  const allPlaceholders = objects.length > 0 && objects.every((o) => editor.placeholders?.isPlaceholder(o));

  return (
    <>
      <TransformSection objects={objects} editor={editor} />
      {allPlaceholders ? (
        <PlaceholderIdentitySection objects={objects} editor={editor} />
      ) : (
        <SlotFilterSection objects={objects} editor={editor} />
      )}
      <VisibleWhenSection objects={objects} editor={editor} />
    </>
  );
};

export default MixedInspector;
